import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Set_Lesson } from "../../actions/curriculums/view";
import { Get_Test } from "../../actions/curriculums/test";
import InfoNote from "../shared/InfoNote";
import { HomePage } from "../../translations/trans";

// من الأفضل نقل هذا إلى ملف CSS
/*
.lesson-tap.lesson-closed {
  cursor: not-allowed;
  opacity: 0.6;
}

.test-tap {
  // يمكنك إضافة مسافة بادئة هنا لتمييز الاختبارات
  margin-right: 20px; 
}
*/

function LessonsTaps({ lessons, setShowTest, unallowedLessons = [] }) {
  const dispatch = useDispatch();
  const { lang } = useSelector((state) => state.language);

  const isLessonClosed = useCallback(
    (lesson) => {
      return lesson.closed;
    },
    [unallowedLessons]
  );

  const getTest = useCallback(
    async (id) => {
      try {
        await dispatch(Get_Test([id]));
        setShowTest(true);
      } catch (err) {
        console.error(err.message);
      }
    },
    [dispatch, setShowTest]
  );

  const handleLessonClick = useCallback(
    (lesson) => {
      if (lesson.closed) return; // skip if locked
      dispatch(Set_Lesson(lesson));
      setShowTest(false);
    },
    [dispatch, isLessonClosed, setShowTest]
  );

  const handleTestClick = useCallback(
    (lesson, testId) => {
      if (isLessonClosed(lesson)) return; // skip if locked
      getTest(testId);
    },
    [getTest, isLessonClosed]
  );

  return (
    <div dir="rtl">
      <ol className="lessons-list">
        {lessons.map((l, i) => {
          const closed = l.closed;
          const itemClass = `lesson-tap ${closed ? "lesson-closed" : ""}`;

          return (
            // استخدام React.Fragment لإصلاح بنية HTML
            <React.Fragment key={l._id || i}>
              <li
                onClick={() => handleLessonClick(l)}
                className={itemClass}
              >
                {i + 1}. {l.name}
                {closed && (
                  <span style={{ color: "red", marginRight: "5px" }}>
                    🔒{" "}
                    <InfoNote
                      note={
                        HomePage.closedLessonNote?.[lang] || "This lesson is locked"
                      }
                    />
                  </span>
                )}
              </li>

              {l.testIDS?.length > 0 &&
                l.testIDS.map((t, idx) => (
                  <li
                    key={t}
                    onClick={() => handleTestClick(l, t)}
                    // إضافة كلاس "test-tap" لتمييزه في CSS
                    className={`${itemClass} test-tap`}
                  >
                    {/* يمكنك إضافة مسافة بادئة هنا أو عبر CSS */}
                    اختبار {idx + 1}
                  </li>
                ))}
            </React.Fragment>
          );
        })}
      </ol>
    </div>
  );
}

export default LessonsTaps;